import { UserRole } from 'config/userRole'
import useUserRights from 'components/libs/userRights/useUserRights'

export { useUserRights }

export enum UserRights {
  GOTO_ENDUSER_APP = UserRole.USER
}
